module.exports = {"222402001":"向上街道","222402002":"新华街道","222402003":"月宫街道","222402100":"月晴镇","222402101":"石岘镇","222402102":"长安镇","222402103":"凉水镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/222402.json
// module id = 665
// module chunks = 0